import axios from "axios";
import * as Endpoints from './endpoints';
import {LicenseInfo} from "../types/LicenseInfo";
import BaseService from "./base-service";

/**
 * Service for semantic objects service /license REST API.
 */
class LicenseService extends BaseService {

  /**
   * Returns the active license information.
   *
   * @returns {Promise<LicenseInfo>}
   */
  static getLicenseInfo(): Promise<LicenseInfo> {
    return axios.get(Endpoints.LICENSE)
      .then(this.resolveResponse)
      .then(this.mapLicenseResponse)
      .catch(this.mapLicenseErrorResponse);
  }

  static validateLicense(licenseFile: File): Promise<LicenseInfo> {
    return axios.post(`${Endpoints.LICENSE}/validate`, LicenseService.toFormData(licenseFile))
      .then(this.resolveResponse)
      .then(this.mapLicenseResponse)
      .catch(this.mapLicenseErrorResponse);
  }

  static updateLicense(licenseFile: File): Promise<LicenseInfo> {
    return axios.post(Endpoints.LICENSE, LicenseService.toFormData(licenseFile))
      .then(this.resolveResponse)
      .then(this.mapLicenseResponse)
      .catch(this.mapLicenseErrorResponse);
  }

  private static mapLicenseResponse(response: any): LicenseInfo {
    return {
      licensedTo: response.licensedTo,
      version: response.version,
      expiryDate: new Date(response.expiryDate),
      publicationDate: response.publicationDate,
      typeOfUse: response.typeOfUse,
      isValid: true
    };
  }

  private static mapLicenseErrorResponse(errorResponse: any): Promise<LicenseInfo> {
    const invalidLicense = {
      isValid: false,
      messages: errorResponse.response?.data?.message
    };
    return Promise.reject(invalidLicense);
  }

  private static toFormData(licenseFile: File): FormData {
    const data = new FormData();
    data.append("license", licenseFile);
    return data;
  }

}

export default LicenseService;
